
import { defineComponent } from "vue";
import TextInput from "@/components/TextInput.vue";
import AccentButton from "@/components/AccentButton.vue";
import TopBlock from "@/components/TopBlock.vue";
// eslint-disable-next-line
import { backend } from "@/main";

export default defineComponent({
  name: "Application",
  data() {
    return {
      sent: false,
      error: false,
      errorMessage: "",
      submitted: false,
      name: "",
      phone: "",
    };
  },
  methods: {
    async buttonHandler() {
      const directus = await backend;
      if (!directus) {
        this.sent = true;
        this.error = true;
        this.errorMessage = "Не удалось подключиться к серверу!";
        setTimeout(() => {
          this.$router.replace("/");
        }, 2000);
        return;
      }
      this.submitted = true;
      if (this.name.length > 0 && this.phone.length > 0) {
        try {
          await directus.items("applications").createOne({
            name: this.name,
            phone: this.phone,
          });
        } catch (error) {
          console.log(error);
          this.error = true;
          this.errorMessage = "Произошла неизвестая ошибка!";
        }
        this.sent = true;
        setTimeout(() => {
          this.$router.replace("/");
        }, 2000);
      }
    },
  },
  components: { TextInput, AccentButton, TopBlock },
});
